import React, { useState } from 'react';

import { history } from '../../../../_helpers/history';
import { connect } from 'react-redux';
import { alertActions } from '../../../../_actions/alert.actions';
import { Button, Modal } from 'react-bootstrap';
import { telehealthService as service } from '../../../../_services/telehealth.service';

function EndAppointment({ telehealthId, dispatch }) {
  const [show, setShow] = useState(false);
  const [ending, setEnding] = useState(false);
  const handleClose = () => { setShow(false); }
  const handleShow = () => { setShow(true); }

  return <>
    <button
      onClick={handleShow}
      className="btn btn-danger">End Appointment</button>

    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>End Appointment</Modal.Title>
      </Modal.Header>

      <Modal.Body>Are you sure you want to end this patient's appointment? To keep the appointment but exit the screen, use the back button.</Modal.Body>

      <Modal.Footer>
        <Button onClick={() => {
          setEnding(true);

          service.endTelehealth(telehealthId)
            .then(() => {
              setEnding(false);
              handleClose();

              history.push('/telehealth');

              dispatch(alertActions.success('Telehealth Ended!'));
            })
            .catch(() => {
              setEnding(false);
              handleClose();

              dispatch(alertActions.error('Could not end the appointment. Please try again later.'));
            });
        }}
          disabled={ending}
          variant="primary"
        >
          Yes, end appointment.
        </Button>
        <Button variant="secondary" className='w-25' onClick={handleClose}>
          No
        </Button>
      </Modal.Footer>
    </Modal>
  </>
}

export default connect()(EndAppointment);